import {HttpParams} from '@angular/common/http';
import {getAuthToken} from 'src/app/api/AuthHeaders';
import {HttpEventType, HttpResponse, HttpHeaders} from '@angular/common/http';
import {HttpEvent} from '@angular/common/http';
import {HttpClient} from '@angular/common/http';
import {FileInfo, UploadBanerResponse} from './../../Models/FileModels';
import {UploadFileQueueComponent} from './../upload-file-queue/upload-file-queue.component';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MainService} from "../../Services/service.service";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SubscribtionService} from '../../Services/subscribtion.service';
import {CreditCardValidator} from 'angular-cc-library';
import {AddBaner} from '../../api/WickedApiClient';
import {environment} from 'src/environments/environment';

export enum PaymentType {PremiumAdToken = 0, WriteAdToken = 1, ThirdPartyToken = 2}
export enum BanerPlatform {Desktop = 0, Mobile = 1}

const imageSizes = {0: {w: 160, h: 600}, 1: {w: 728, h: 90}, 2: {w: 300, h: 100}};

@Component({
  selector: 'baner-token-payment',
  templateUrl: './baner-token-payment.component.html',
  styleUrls: ['./baner-token-payment.component.scss']
})
export class BanerTokenPaymentComponent implements OnInit {

  public form: FormGroup;

  protected creating: boolean = false;

  public banerPlatform: BanerPlatform = BanerPlatform.Desktop;

  @Input() paymentFormType: PaymentType = PaymentType.PremiumAdToken;

  @Input() payButtonText: string = "Pay";

  @Output() onTokenAdded = new EventEmitter();

  @ViewChild("fileUploadQueue", {static: true}) fileUploadQueue: UploadFileQueueComponent; This: any = this;

  private _termsNotAccepted: boolean = true;

  public get termsNotAccepted(): boolean {
    return this._termsNotAccepted;
  }
  public set termsNotAccepted(value: boolean) {
    this._termsNotAccepted = value;
  }


  imagesChanged: boolean = false;
  private _selectedImages: Array<FileInfo> = [];
  public get selectedImages(): Array<FileInfo> {
    return this._selectedImages;
  }


  constructor(public services: MainService, private fb: FormBuilder, private subscribtionService: SubscribtionService, private HttpClient: HttpClient) { }

  ngOnInit() {
    this.form = this.fb.group({
      firstName: ['', [<any>Validators.required]],
      lastName: ['', [<any>Validators.required]],
      zip: ['', [<any>Validators.required]],
      creditCard: ['', [<any>CreditCardValidator.validateCCNumber]],
      expirationDateYear: ['', [<any>Validators.required]],
      expirationDateMonth: ['', [<any>Validators.required]],
      cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
      banerUrl: ['', [<any>Validators.required]]
    });
  }

  onSubmit() {
    if(this.form.dirty && this.form.valid) {
      if(!this.termsNotAccepted) {
        if(this.selectedImages[0] && this.selectedImages[1] && this.banerPlatform == BanerPlatform.Desktop) {
          this.sendForm();
        } else if(this.selectedImages[2] && this.banerPlatform == BanerPlatform.Mobile) {
          this.sendForm();
        }
        else {
          this.services.showError("Please select image");
        }
      } else {
        this.services.showError("Please accept terms");
      }
    }
  }

  sendForm() {
    let data: AddBaner = new AddBaner({
      firstName: this.form.controls["firstName"].value,
      lastName: this.form.controls["lastName"].value,
      cardNumber: this.form.controls["creditCard"].value,
      expirationDate: `${this.form.controls["expirationDateYear"].value}-${this.form.controls["expirationDateMonth"].value}`,
      zip: this.form.controls["zip"].value,
      securityCode: this.form.controls["cvc"].value,
      banerUrl: this.form.controls["banerUrl"].value,
      desktopImageVertical: this.banerPlatform == 0 ? this.selectedImages[0].imageUrl : "",
      desktopImageHorizontal: this.banerPlatform == 0 ? this.selectedImages[1].imageUrl : "",
      mobileImage: this.banerPlatform == 1 ? this.selectedImages[2].imageUrl : "",
      isMobile: this.banerPlatform
    })
    this.creating = true;

    this.subscribtionService.createBanerAdvertising(data).then((response) => {
      this.creating = false;
      this.onTokenAdded.emit(response);
    });
  }

  //image uplad functions


  isImage(file: File) {
    let name = file.name.toLowerCase();
    return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
  }

  addFile(file: File, inputId: number = null) {
    console.log(file);
    if(this.isImage(file) && typeof inputId == 'number') {
      var fi = new FileInfo();
      fi.file = file;
      fi.fileName = file.name;
      fi.name = file.name;
      fi.orgFileName = file.name;
      //fi.advertisementId = this.adv ? this.adv.advertisementId : null;
      var reader = new FileReader();
      reader.onload = e => {
        const readerSrc = e.target["result"].toString();
        var image = new Image();
        image.src = readerSrc;
        image.onload = () => {
          if((image.width == imageSizes[inputId].w && image.height == imageSizes[inputId].h)) {
            fi.imageUrl = <string>reader.result;
            this.uploadFile(fi);
            if(!this.selectedImages[inputId]) {
              this.selectedImages[inputId] = fi;
            }
            this.imagesChanged = true;
          } else {
            this.services.showError("Please select an image with the correct resolution 160x600 or 728x90");
          }
        };
      };
      reader.readAsDataURL(fi.file);
    }
  }

  deleteImage(file: FileInfo, inputId: number) {

    if(this.selectedImages[inputId] == file) {
      this.setSelectedImages(undefined, inputId);
    }

    this.imagesChanged = true;
  }

  uploadFile(file: FileInfo) {
    var url = "/File/TemporaryBanerUpload";
    let formData = new FormData();
    let token = getAuthToken();
    var headers = new HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
    var httpRequestParams = new HttpParams();
    headers.set("Authorization", "Bearer " + token);
    formData.set("file", file.file, file.file.name);
    this.services.progress = true;
    this.HttpClient.post(url, formData, {
      headers: headers,
      observe: "events",
      params: httpRequestParams,
      reportProgress: true,
      responseType: "json"
    }).subscribe(
      (event: HttpEvent<Object>) => {
        if(event.type === HttpEventType.UploadProgress) {
          file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
          file.loaded = event.loaded;
        }
        if(event.type == HttpEventType.Response) {
          var eventResponse = <HttpResponse<UploadBanerResponse>>event;
          if(eventResponse.body && eventResponse.ok) {
            if(eventResponse.body.isBanerSize) {
              file.fileName = eventResponse.body.files[0].localFilename;
              file.isUploading = false;
              file.imageUrl = `${environment.apiBaseUrl}/FileGet/${file.fileName}`;
            } else {
              this.services.showError("Please select an image with the correct resolution 160x600, 728x90 or 300x100 for mobile");
            }
          }
          this.services.progress = false;
        }
      },
      (error: any) => {
        file.isUploading = false;
        this.services.progress = false;
      },
      () => {
      }
    );
  }

  public setSelectedImages(value: FileInfo, index: number) {
    console.log(value);
    if(value != this._selectedImages[index]) {
      this.imagesChanged = true;
    }
    this._selectedImages[index] = value;
  }

  public termsAcceptAction(e) {
    this.termsNotAccepted = !e.checked
  }

  public changeBanerPlatform(e) {
    this.banerPlatform = e.value;
  }

  public isBanerMobile() {
    return this.banerPlatform == BanerPlatform.Mobile;
  }

}
